module.exports = __webpack_public_path__ + "static/media/ending-BG.d65f844c.jpg";